import {accessControlDialogCreate} from "../_resources/accesscontrol-dialog.js";
import {runWaffleSyncACL, runWaffleSyncDCL, timediff} from "../_resources/waffle-helpers.js";
import {buildFormToAddBranch, buildFormToAddDataset} from "./datasetsTableForms.js";
import { holdButton } from "../_resources/ui-library.js";
import { supabaseClient } from "../auth/supabase.service";
import { syncDataset }  from "./syncButton.js";
import { getSupaAccess, checkSupaAccess, emojifyLevel } from "../_resources/supa-helpers.js";

let showDummyDatasets = false;
let collapseRepositoryColumn = true;
let branchesMissingFromSupa = {};
let branchesMissingFromServer = {};
const isBranchForAddition = (slug, branch) => branch && branchesMissingFromServer[slug] && branchesMissingFromServer[slug][branch]; 
const isBranchForDeletion = (slug, branch) => branch && branchesMissingFromSupa[slug] && branchesMissingFromSupa[slug][branch]; 

const getDsGithubUrl = (dataset) => `https://github.com/${dataset.githubRepoId}`;

function formatCommitAge(commitTimeStamp, slug, branch, longlabels){
  const ts = (commitTimeStamp?.[slug] || {})[branch];
  if (!ts) return "";
  const age = timediff(ts, true, false, longlabels);
  return `<span title="${ts.split(".")[0].replace("T", " at ")} UTC">${age}</span>`
}


function mergeDatasetsFromServerAndWaffle({serverDatasets, supaDatasets}){
  for (let serverDS of serverDatasets){
    const supaDS = supaDatasets.find(w => w.slug === serverDS.slug);
    if (!supaDS)
      serverDS.missingFromSupa = true;
    else
      serverDS.branches = joinBranches({serverDS, supaDS});
  }

  for (let supaDS of supaDatasets){
    const dataset = serverDatasets.find(d => d.slug === supaDS.slug);
    if (!dataset){
      supaDS.missingFromServer = true;        
      serverDatasets.push(supaDS);
    }
  }
  return serverDatasets;
}

function joinBranches({serverDS, supaDS}){
  const slug = serverDS.slug;

  for (let serverBranch of serverDS.branches){
    const supaBranch = supaDS.branches.includes(serverBranch);
    if (!supaBranch)
      (branchesMissingFromSupa[slug] ??= {})[serverBranch] = true;
  }

  for (let supaBranch of supaDS.branches){
    const serverBranch = serverDS.branches.includes(supaBranch);
    if (!serverBranch){
      (branchesMissingFromServer[slug] ??= {})[supaBranch] = true;
      serverDS.branches.push(supaBranch);
    }
  }
  return serverDS.branches;
}




export default function ServerDatasetsSectionView({ dom, refresh, bad, info, progress, good }) {
  const container = dom;
  let lastRenderArgs = null;

  const sectionHeader = container.append("div").class("admin-section-header");
  const title = sectionHeader.append("h1");

  const actionsBox = sectionHeader.append("div").class("actionsbox").style("visibility", "hidden");
  const addNewButtonEl = actionsBox.append("button").class("button addnew").text("✚ Add a new dataset")
  const syncAllButtonEl = actionsBox.append("button").class("button hold-btn").text("↻ SYNC EVERYTHING");
  const kebabMenu = actionsBox.append("div")
    .class("kebabmenu")
    .style("visibility", "hidden")
  actionsBox.append("button").class("button").text("⋮")
    .on("click", function() {
      const isVisible = kebabMenu.style("visibility") === "visible";
      kebabMenu.style("visibility", isVisible ? "hidden" : "visible");
    });
  const syncAccessControlButtonEl = kebabMenu.append("a").text("↻ Sync only permissions");
  const syncDatasetControlButtonEl = kebabMenu.append("a").text("↻ Sync only dataset list");
  const toggleDummyDatasets = kebabMenu.append("a").class("showhide-dummy").text(`${showDummyDatasets ? "Hide" : "Show"} dummy datasets`);
    


  container.append("table");
  const formEl = container.append('form').attr('class', 'form').style("visibility", "hidden");

  container.append("div").class("admin-section-footer");   

  const showAllAddButtons = () => container.selectAll("button.addnew").style("visibility", null);
  const hideAllAddButtons = () => container.selectAll("button.addnew").style("visibility", "hidden");



  function render({
    serverDatasetSlugToBranchToCommitMapping, 
    commitTimeStamp,
    commitAuthor,
    serverDatasets, 
    supaDatasets,
    supaPageDatasources,
    datasetInfo, 
    supaACL, 
    selectedServerId, 
    selectedServerUrl,
    token, userId
  }) {
    lastRenderArgs = {serverDatasetSlugToBranchToCommitMapping, commitTimeStamp, commitAuthor, serverDatasets, supaDatasets, supaPageDatasources, datasetInfo, supaACL, selectedServerId, selectedServerUrl, token, userId};
    const serverAccessLevel = getSupaAccess({user: userId, scope: "server", resource: selectedServerId});
    title
      .html(`Datasets of ${selectedServerId} ${emojifyLevel(serverAccessLevel)} <span class="shy">your server access level: ${serverAccessLevel}</span>`);

    actionsBox.style("visibility", "visible");
    
    branchesMissingFromServer = {};
    branchesMissingFromSupa = {};
    serverDatasets = mergeDatasetsFromServerAndWaffle({serverDatasets, supaDatasets});

    const maxBranches = d3.max(serverDatasets, d => d.branches.length);
    const usedByHowManyPageDatasources = d3.rollup(supaPageDatasources, v => v.length, d => d.reader_properties.dataset);
    const isDummyDataset = (dataset) => supaDatasets.find(f => f.slug === dataset.slug && f.server === "__all__");
    const getDefaultBranchOnSupa = (dataset) => supaDatasets.find(f => f.slug === dataset.slug)?.default_branch;
  
    const hasServerEditAccess = checkSupaAccess({user: userId, scope: "server", resource: selectedServerId, atLeast: "editor"});
    const hasServerOwnerAccess = checkSupaAccess({user: userId, scope: "server", resource: selectedServerId, atLeast: "owner"});
    syncAllButtonEl.classed("disabled", !hasServerEditAccess);
    syncAccessControlButtonEl.classed("disabled", !hasServerEditAccess);
    syncDatasetControlButtonEl.classed("disabled", !hasServerEditAccess);
    addNewButtonEl.classed("disabled", !hasServerEditAccess);

    const table = container.select("table")
      .class("admin-table")
      .style("max-width", "none");
    table.selectAll("tr,colgroup").remove();
  
    if (serverDatasets.length > 0) table.append("colgroup")
      .call((group) => {
        group.append("col")
        group.append("col").style("width", collapseRepositoryColumn ? "30%" : "40%")
        group.append("col")
        group.append("col").style("width", collapseRepositoryColumn ? "50%" : "40%").style("min-width", (maxBranches*100) + "px")
        group.append("col")
      })
    if (serverDatasets.length > 0) table.append("tr")
      .call((rowEl) => {
        rowEl.append("th").html("")
        rowEl.append("th").call(cell => {
          const gridbox = cell.append("div").class("gridbox one-or-two-subcolumns").classed("collapsed", collapseRepositoryColumn)
          gridbox.append("div").html("Slug")
          gridbox.append("div")
            .html(collapseRepositoryColumn ? "Repo" : "Repository")
            .style("text-decoration", "underline")
            .style("cursor", "pointer")
            .on("click", () => {
              collapseRepositoryColumn = !collapseRepositoryColumn;
              if (lastRenderArgs) render(lastRenderArgs);
            });
        })
        rowEl.append("th").html("Add<br/>a⼘").attr("title", "Add a new branch or change the default branch")
        rowEl.append("th").html('Branches <br/> when last updated')
        rowEl.append("th").html("Access")
      })
    if (serverDatasets.length > 0) table.selectAll("tr.dataset")
      .data(d3.sort(serverDatasets, d => d.slug))
      .enter().append("tr")
      .class("dataset")
      .classed("for-addition", d => d.missingFromServer)
      .classed("for-deletion", d => d.missingFromSupa)
      .classed("is-dummy", isDummyDataset)
      .classed("nonremovable", isDummyDataset)
      .style("display", d => showDummyDatasets || !isDummyDataset(d) ? null: "none")
      .each(function(dataset){
        const rowEl = d3.select(this);
        const hasDatasetEditAccess = checkSupaAccess({user: userId, scope: "dataset", resource: dataset.slug, atLeast: "editor"});
        const canEditDS = dataset.is_private ? hasDatasetEditAccess && hasServerEditAccess || hasServerOwnerAccess : hasServerEditAccess;

        rowEl.append("td").append("div").class("actionsbox column").call(group => {
          const syncButton = group.append("button") 
            .class("button hold-btn")
            .classed("disabled", !canEditDS)
            .text("↻ Sync");

          holdButton(syncButton, () => syncDataset({selectedServerUrl, slug: dataset.slug, token, good, info, progress, bad, refresh}));

          const deleteButton = group.append("button") 
            .class("button delete hold-btn")
            .classed("disabled", !canEditDS)
            .text(`Delete`);
  
          holdButton(deleteButton, () => deleteDataset({dataset, selectedServerId, refresh, bad, info, good}) );
        })
  
        rowEl.append("td")
          .call(cell => {
            const gridbox = cell.append("div").class("gridbox one-or-two-subcolumns").classed("collapsed", collapseRepositoryColumn)

            gridbox.append("div").style("font-size", "1.3em")
              .text((dataset.is_private ? "🔒 " : "") + dataset.slug)
            if (collapseRepositoryColumn) {
              gridbox.append("div")
                .html(`<a href="${getDsGithubUrl(dataset)}" target="_blank">GitHub</a>`);
            } else {
              gridbox.append("div")
                .html(`<a href="${getDsGithubUrl(dataset)}" target="_blank">${dataset.githubRepoId.split("/")[1]}</a> <br/> <span style="color:#546375"> @${dataset.githubRepoId.split("/")[0]} </span> ${dataset.waffleFetcherAppInstallationId ? '<br/> <span style="color: #546375">via Waffle Fetcher ' + dataset.waffleFetcherAppInstallationId + '</span>': ""}`);
            }
          })


        rowEl.append("td")
          .append("button")
          .class("button addnew")
          .classed("disabled", !canEditDS)
          .html(`✚`)
          .on("click", () => buildFormToAddBranch({
            formEl, 
            dataset, 
            getDefaultBranchOnSupa,
            action: (args) => {
              return supabaseClient
                .from('waffle')
                .update(args)
                .eq('id', dataset.slug)
                .eq('server', selectedServerId)
            }, 
            onActionSuccess: refresh, 
            onFormInit: hideAllAddButtons, 
            onFormDestroy: showAllAddButtons, 
            bad,info,good
          }));
          
        rowEl.append("td").class("branches")
          .call(cell => {
            cell.append("div").class("gridbox even-width")
              .selectAll("div.branch")
              .data(Array(maxBranches))
              .enter().append("div")
              .class("branch")
              .classed("for-addition", (_, i) => !dataset.missingFromServer && isBranchForAddition(dataset.slug, dataset.branches[i]))
              .classed("for-deletion", (_, i) => !dataset.missingFromSupa && isBranchForDeletion(dataset.slug, dataset.branches[i]))
              .style("font-family","Monospace")
              .each(function(_,i){
                const branch = dataset.branches[i];
                if(!branch) return;

                const view = d3.select(this);
                const slug = dataset.slug;

                const formatBranchCommit = (branch, slug) => {
                  const commit = (serverDatasetSlugToBranchToCommitMapping[slug]||{})[branch]?.substr(0,7);
                  return `${branch}: ${commit||"NEEDS SYNC"}`
                }

                const isTheOnlyBranch = dataset.branches.length <= 1;
                const isDefaultBranch = !isTheOnlyBranch && dataset.default_branch === branch;

                view.append("div").class("branchname").classed("default",isDefaultBranch)
                  .attr("title", isDefaultBranch?"Default branch":"").html(formatBranchCommit(branch, slug));
                view.append("div").html(formatCommitAge(commitTimeStamp, slug, branch, maxBranches < 3));
                view.append("div").html("·".repeat(usedByHowManyPageDatasources.get(`${slug}/${branch}`) || 0));

                view.append("div").class("actionsbox micro")
                  .style("visibility", () => isTheOnlyBranch ? "hidden" : null)
                  .call((group) => {
                    const syncButton = group.append("button")
                      .class("button micro hold-btn")
                      .classed("disabled", !canEditDS)
                      .style("min-width", "45px")
                      .text("↻ sync");

                    holdButton(syncButton, () => syncDataset({selectedServerUrl, slug, branch, token, good, info, progress, bad, refresh}));

                    const deleteButton = group.append("button") 
                      .class("button delete micro hold-btn")
                      .classed("disabled", !canEditDS)
                      .text("✘")
        
                    holdButton(deleteButton, () => deleteBranch({branch, dataset, getDefaultBranchOnSupa, selectedServerId, refresh, bad, info, good}));
                  })

                view.append("div").class("overlay")
                  .on("mouseenter", () => good("Sync all dataset to apply changes. Partial sync when adding/removing datasets or branches is not implemented yet"))
                  .on("mouseout", () => info());
              })
      
          });

          
        

        const hasDatasetOwnerAccess = checkSupaAccess({user: userId, scope: "dataset", resource: dataset.slug, atLeast: "owner"});
        const aclForDataset = supaACL.entries().filter(([k]) => k.includes(`dataset.${dataset.slug}`)).map(([k,v]) => v);
        const dba = d3.rollup(aclForDataset, v => v.length, d => d);
        if(!dataset.is_private) {
          const conceptsUrl = `${selectedServerUrl}v2/${dataset.slug}?_language=en&select_key@=concept;&value@=concept/_type&=name;;&from=concepts&cachebypass=${Date.now()}`;
          rowEl.append("td")
            .attr("title", "Click to test in a new tab (cache bypassed)")
            .html(`Public <a href="${conceptsUrl}" target="_blank"> <a/>`);
        } else if(hasDatasetOwnerAccess){

          const td = rowEl.append("td");
          td.append("div")
            .style("margin-bottom", "10px") 
            .text(`👀 ${dba.get("reader") || 0}, ✏️ ${dba.get("editor") || 0}, 👑 ${dba.get("owner") || 0}`)
            
            
          td.append("div").append("button")
            .class("button")
            .text("Edit access")
            .on("click", async () => {
              await accessControlDialogCreate({scope: "dataset", resource: dataset.slug, selectedServerId});
            })
        } else
          rowEl.append("td").text("Not an owner")

        rowEl.append("div").class("overlay")
          .on("mouseenter", () => good("Sync all dataset to apply changes. Partial sync when adding/removing datasets or branches is not implemented yet"))
          .on("mouseout", () => info());
      })
      
    addNewButtonEl.on("click", () => buildFormToAddDataset({
        formEl, 
        datasets: serverDatasets, 
        action: (args) => {
          return supabaseClient
            .from('waffle')
            .insert({
              ...args, 
              server: selectedServerId
            });
        }, 
        onActionSuccess: refresh, 
        onFormInit: hideAllAddButtons, 
        onFormDestroy: showAllAddButtons, 
        bad,info,good
      }));

      holdButton(syncAllButtonEl, () => syncDataset({ selectedServerUrl, token, good, info, progress, bad, refresh }));
      syncAccessControlButtonEl.on("click", async () => {
        const {ok, error} = await runWaffleSyncACL(selectedServerId);
        if (error) return bad(error); //❌
        const permisssionsChanged = `user rules: ${ok.oldUserRuleNumber} → ${ok.newUserRuleNumber}, permalink rules: ${ok.oldPermalinkRuleNumber} → ${ok.newPermalinkRuleNumber}`;
        if (ok) good("Permissions updated: " + permisssionsChanged, 3000); //✅
        kebabMenu.style("visibility", "hidden");
      });
      syncDatasetControlButtonEl.on("click", async () => {
        const {ok, error} = await runWaffleSyncDCL(selectedServerUrl, token);
        if (error) return bad(error); //❌
        if (ok) good("Dataset list updated", 2000); //✅
        kebabMenu.style("visibility", "hidden");
      });
      toggleDummyDatasets.on("click", () => {
        showDummyDatasets = !showDummyDatasets;
        table.selectAll("tr.dataset.is-dummy")
          .style("display", showDummyDatasets || !isDummyDataset ? null: "none")
        kebabMenu.selectAll("a.showhide-dummy").text(`${showDummyDatasets ? "Hide" : "Show"} dummy datasets`);
        kebabMenu.style("visibility", "hidden");
      });

    return container;
  }

  function renderError(message) {
    title.text(message);
    actionsBox.style("visibility", "hidden");
    container.select("table").selectAll("tr,colgroup").remove();
  }

  return {render, renderError};
}




async function deleteBranch({branch, dataset, getDefaultBranchOnSupa, selectedServerId, refresh, bad, info, good}){
  if (!branch) 
    return bad("BUG: branch not provided"); //❌
  if (!dataset.branches.filter(f => f!==branch)) 
    return bad("Can't delete the last remaining branch. Delete entire dataset instead."); //❌

  const defaultOnSupa = getDefaultBranchOnSupa(dataset);
  const possiblyResetDefault = defaultOnSupa === branch ? {default_branch: null} : {};
  const { error } = await supabaseClient
    .from('waffle')
    .update({ branches: dataset.branches.filter(f => f!==branch).join(","), ...possiblyResetDefault })
    .eq('id', dataset.slug)
    .eq('server', selectedServerId)

  if (error) return bad(error.message || "Didn't succeed deleting the branch"); //❌
  good('Branch scheduled for deletion', 1000); //✅
  refresh();
}


async function deleteDataset({dataset, selectedServerId, refresh, bad, info, good}){
  if (!dataset) 
    return bad("BUG: daset not provided"); //❌

  const { error } = await supabaseClient
    .from('waffle')
    .delete()
    .eq("id", dataset.slug)
    .eq("server", selectedServerId)

  if (error) bad(error.message || "Didn't succeed deleting the dataset"); //❌
  good('Dataset scheduled for deletion', 1000); //✅
  refresh();
}
